<template>
  <div id="up-nav-topbar" class="flex items-center px-2 bg-white h-14">
    <div id="up-nav-topbar__avatar" class="ml-auto mr-4">
      <slot name="avatarIndicator"></slot>
    </div>
  </div>
  <div>
    <slot name="avatarMenu"></slot>
  </div>
</template>
<script setup lang="ts"></script>
